import { css } from '@emotion/react';

export const layoutStyles = {
    mainContainer: css`
        display: flex;
        width: 100%;
        height: calc(100vh - 50px);
        position: relative;
        overflow: hidden;
    `,
    sidebarWrapper: css`
        position: relative;
        display: flex;
    `,
    sidebar: css`
        display: flex;
        flex-shrink: 0;
        width: clamp(500px, 32vw, 600px);
        min-width: 500px;
        border-right: 1px solid #e4e8f0;
        background-color: #fff;
        transition: width 0.25s ease;
    `,
    sidebarCollapsed: css`
        width: 54px;
        min-width: 54px;
        max-width: 54px;
    `,
    sidebarContent: css`
        flex: 1;
        min-width: 0;
        height: 100%;
        display: flex;
        flex-direction: column;
        padding: 10px 12px;
        gap: 10px;
        overflow-y: auto;
        background-color: #fff;
    `,
    sidebarContentWrapper: css`
        position: relative;
        flex: 1;
        min-width: 0;
        height: 100%;
        display: flex;
        flex-direction: column;
        padding-right: 6px;
    `,
    contentArea: css`
        flex: 1;
        min-width: 0;
        height: 100%;
        display: flex;
        flex-direction: column;
        background-color: #f8fafc;
    `,
    collapseToggleButtonCollapsed: css`
        position: absolute; 
        top: 50%; 
        right: 0; 
        transform: translate(100%, -50%);
        
        display: flex;
        align-items: center;
        justify-content: center;
        
        width: 24px;   
        height: 60px;  
        border-radius:  0 4px 4px 0; 
        
        background-color: #ffffff; 
        border: none;
        
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1); 
        
        cursor: pointer;
        z-index: 10; 

        color: #888888; 

        &:hover {
            background-color:rgb(248, 248, 248); 
        }
    `,
    inlineCollapseButton: css`
        position: absolute; 
        top: 50%; 
        right: 0; 
        transform: translate(100%, -50%);
        
        display: flex;
        align-items: center;
        justify-content: center;
        
        width: 24px;   
        height: 60px;  
        border-radius:  0 4px 4px 0; 
        
        background-color: #ffffff; 
        border: none;
        
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1); 
        
        cursor: pointer;
        z-index: 10; 

        color: #888888; 

        &:hover {
            background-color:rgb(248, 248, 248); 
        }
    `,
};
